import { useQuery } from "react-query"
import { get_user_info } from "../../services/user";


const useUser = (email) => {
    return useQuery('get_user_info', ()=>get_user_info())
}

export default useUser;